var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5570_5908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.7656C17.5751 22.7656 22.5 17.8408 22.5 11.7656C22.5 5.69049 17.5751 0.765625 11.5 0.765625C5.42487 0.765625 0.5 5.69049 0.5 11.7656C0.5 17.8408 5.42487 22.7656 11.5 22.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77387 5.06836C1.90981 6.19255 1.25828 7.48828 0.878906 8.89589H6.6014L2.77387 5.06836Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1208 8.89585C21.7415 7.48828 21.0899 6.19255 20.2259 5.06836L16.3984 8.89585H22.1208Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 14.6348C1.25832 16.0423 1.90986 17.3381 2.77387 18.4622L6.60127 14.6348H0.878906Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1966 3.03954C17.0724 2.17548 15.7768 1.52395 14.3691 1.14453V6.86698L18.1966 3.03954Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80273 20.4915C5.92693 21.3555 7.22265 22.0071 8.63022 22.3865V16.6641L4.80273 20.4915Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63018 1.14453C7.22261 1.52395 5.92688 2.17548 4.80273 3.0395L8.63018 6.86694V1.14453Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3691 22.3865C15.7767 22.0071 17.0724 21.3555 18.1966 20.4915L14.3691 16.6641V22.3865Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3984 14.6348L20.2259 18.4622C21.0899 17.3381 21.7415 16.0423 22.1208 14.6348H16.3984Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4069 10.3309H12.9349H12.9348V0.858738C12.4651 0.797594 11.9863 0.765625 11.5 0.765625C11.0136 0.765625 10.5349 0.797594 10.0652 0.858738V10.3308V10.3308H0.593113C0.531969 10.8005 0.5 11.2793 0.5 11.7656C0.5 12.252 0.531969 12.7307 0.593113 13.2004H10.0651H10.0652V22.6725C10.5349 22.7337 11.0136 22.7656 11.5 22.7656C11.9863 22.7656 12.4651 22.7337 12.9348 22.6725V13.2005V13.2004H22.4069C22.468 12.7307 22.5 12.252 22.5 11.7656C22.5 11.2793 22.468 10.8005 22.4069 10.3309V10.3309Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3701 14.6348L19.2787 19.5434C19.5045 19.3177 19.7198 19.0818 19.9253 18.8372L15.7229 14.6348H14.3701V14.6348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6303 14.6348H8.63021L3.72168 19.5433C3.94735 19.7691 4.18329 19.9844 4.42787 20.1899L8.6303 15.9874V14.6348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63037 8.89699V8.8969L3.72179 3.98828C3.49603 4.21395 3.28067 4.44989 3.0752 4.69447L7.27767 8.89695H8.63037V8.89699Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3701 8.89701L19.2787 3.98835C19.0531 3.76259 18.8171 3.54723 18.5725 3.3418L14.3701 7.54427V8.89701Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5570_5908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5 0.765625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk-flag.37b46fcfc4d72f7c3923136c1b4f52b3.svg";
export { ForwardRef as ReactComponent };